/**
 * 訂單狀態管理組件
 * 用於後台更新訂單狀態
 */

import { useState } from 'react';
import { supabase } from '@/lib/supabase';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';

export function OrderStatusManager({ order, onUpdate }) {
  const [paymentStatus, setPaymentStatus] = useState(order.payment_status);
  const [orderStatus, setOrderStatus] = useState(order.order_status);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleUpdate = async () => {
    setLoading(true);
    setSuccess(false);

    try {
      const { error } = await supabase
        .from('orders')
        .update({
          payment_status: paymentStatus,
          order_status: orderStatus,
          updated_at: new Date().toISOString(),
        })
        .eq('id', order.id);

      if (error) throw error;

      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        onUpdate?.();
      }, 1500);
    } catch (error) {
      console.error('更新訂單狀態失敗:', error);
      alert('更新失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-gray-700 mb-2 block">
            付款狀態
          </label>
          <Select value={paymentStatus} onValueChange={setPaymentStatus}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="pending">待付款</SelectItem>
              <SelectItem value="paid">已付款</SelectItem>
              <SelectItem value="failed">付款失敗</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 mb-2 block">
            訂單狀態
          </label>
          <Select value={orderStatus} onValueChange={setOrderStatus}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="pending">待處理</SelectItem>
              <SelectItem value="confirmed">已確認</SelectItem>
              <SelectItem value="processing">處理中</SelectItem>
              <SelectItem value="shipped">已出貨</SelectItem>
              <SelectItem value="delivered">已送達</SelectItem>
              <SelectItem value="cancelled">已取消</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <Button
        onClick={handleUpdate}
        disabled={loading || (paymentStatus === order.payment_status && orderStatus === order.order_status)}
        className="w-full"
      >
        {loading ? (
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
            更新中...
          </div>
        ) : success ? (
          <div className="flex items-center gap-2">
            <CheckCircle className="h-4 w-4" />
            已更新
          </div>
        ) : (
          '更新狀態'
        )}
      </Button>
    </div>
  );
}

export default OrderStatusManager;
